import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { CommonVariable } from "src/app/app.constants";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { NgStyle } from "@angular/common";
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from "@angular/material/expansion";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-win-more-promise-popup",
    templateUrl: "./win-more-promise-popup.component.html",
    styleUrls: ["./win-more-promise-popup.component.scss"],
    standalone: true,
    imports: [
        NgStyle,
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelHeader,
        MatExpansionPanelTitle,
        IonicModule,
        TranslatePipe,
    ],
})
export class WinMorePromisePopupComponent implements OnInit {
  public panelOpenState: boolean; // Boolean variable
  public winMorePromiseDetails?: Data; // Data variable
  public days: number; // Number of days
  public hours: number; // Number of hours
  public seconds: number; // Number of seconds
  public minutes: number; // Number of minutes
  public selectedSyndicateData?: Data; // syndicateData variable
  constructor(
    private matDialogRef: MatDialog,
    private syndicateDataService: SyndicateDataService,
    private dialog: MatDialogRef<WinMorePromisePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Data,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : CommonVariable?.preferredLanguage);
        }
      },
      (err) => {
        return err;
      }
    );
  }
   public ngOnInit() {
    this.selectedSyndicateData = this.data; // Get SelectedSyndicateData from Mat_DIALOG
    console.log("selectedSyndicateData",this.selectedSyndicateData)
    }

  public ngAfterViewInit(): void {
    const timeInterval = 1000;
    setInterval(() => {
      
      // Condition for selected win_more_promise_details
      if (this.selectedSyndicateData?.win_more_promise_details) {
        this.winMorePromiseDetails = this.selectedSyndicateData?.win_more_promise_details;
        const targetTime: number = this.winMorePromiseDetails.end_date.toDate().getTime(); //Get Target Time
        const currentTime = new Date().getTime(); //Get Current Time
        const TimeDifference = targetTime - currentTime; // Get Time Difference
        const thousand = 1000; //  Thousand
        const sixty = 60; // sixty [min / sec]
        const twentyFour = 24; // twentyFour HR
        this.days = Math.floor(TimeDifference / (thousand * sixty * sixty * twentyFour)); // Get Days
        this.hours = Math.floor(
          (TimeDifference % (thousand * sixty * sixty * twentyFour)) / (thousand * sixty * sixty)
        ); //Get Hours
        this.minutes = Math.floor((TimeDifference % (thousand * sixty * sixty)) / (thousand * sixty)); //Get Minutes
        this.seconds = Math.floor((TimeDifference % (thousand * sixty)) / thousand); //Get Seconds
      }
    }, timeInterval);
  }
  // This method has been used to get progress bar value
  getProgressBar(isAlone: boolean) {
    const promiseDetails = this.selectedSyndicateData?.win_more_promise_details;
    if (promiseDetails) {
      const aloneCount = promiseDetails?.alone_win_count;
      const togetherCount = promiseDetails?.together_win_count;
      const totalWinnings = togetherCount + aloneCount;
      const progress = Math.round(((isAlone ? aloneCount : togetherCount) / totalWinnings) * 100);
      return progress;
    } else {
      return 0;
    }
  }

  // close box
  closeBox() {
    this.matDialogRef.closeAll();
    this.dialog.close(true);
  }
}

